import { UserMenuContent } from "./UserMenuContent";
import { useTranslation } from "react-i18next";
import { focusRing } from "../ui/control-styles";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "../ui/dropdown-menu";
import type { AuthUser } from "../../auth/auth";

export function AccountControl({
  user,
  onSignOut,
}: {
  user: AuthUser | null;
  onSignOut: () => void;
}) {
  const { t } = useTranslation();
  if (!user) return null;

  return (
    // Not modal, so the rest of the dock stays usable while the menu is open.
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        aria-label={t("auth.accountMenu")}
        title={t("auth.accountMenu")}
        className={`relative z-48 grid size-8 shrink-0 cursor-pointer place-items-center rounded-full text-foreground hover:ring-4 hover:ring-accent ${focusRing} data-[state=open]:ring-4 data-[state=open]:ring-accent`}
      >
        <Avatar className="size-8 border border-dock-divider bg-dock-pill">
          <AvatarImage
            src={user.picture || undefined}
            alt=""
            referrerPolicy="no-referrer"
            className="object-cover"
          />
          <AvatarFallback className="bg-transparent text-white">
            {user.name?.slice(0, 1).toUpperCase()}
          </AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="top"
        align="start"
        sideOffset={8}
        className="w-[min(15.625rem,calc(100vw-1rem))]"
      >
        <UserMenuContent user={user} onSignOut={onSignOut} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
